import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISalesRequirementModel extends IModel {
  salesRequirementId: number;
  name: string;
  inactive: boolean;
}

export class SalesRequirementModel
  extends Model
  implements ModelRecord<ISalesRequirementModel>
{
  salesRequirementId: number;
  name: string;
  inactive: boolean;
  constructor(params?: Partial<ISalesRequirementModel>) {
    super(params);
    this.salesRequirementId = defaultTo(params?.salesRequirementId, 0);
    this.name = defaultTo(params?.name, '');
    this.inactive = defaultTo(params?.inactive, false);
  }
}
